export default "__VITE_ASSET__d63706c4__"